import { isIterable } from "@thi.ng/checks";
import { __drain } from "../internal/drain";
import { iterator } from "../iterator";
export function takeLast(n, src) {
    return isIterable(src)
        ? iterator(takeLast(n), src)
        : ([init, complete, reduce]) => {
            const buf = [];
            return [
                init,
                __drain(buf, complete, reduce),
                (acc, x) => {
                    if (buf.length === n) {
                        buf.shift();
                    }
                    buf.push(x);
                    return acc;
                },
            ];
        };
}
